const BACKEND_URL = "https://tehzwen.duckdns.org";
// const BACKEND_URL = "http://localhost:3001";
const DIFFUSE_TEXTURES = [
  "default.jpg",
  "scifiwallDiffuse.jpg",
  "metalGrillDiffuse.jpg",
  "metalGrill2Diffuse.jpg",
  "moon.jpg",
  "fruit.jpg",
  "plywood.jpg",
];
const NORMAL_TEXTURES = [
  "defaultNorm.jpg",
  "scifiwallNormal.jpg",
  "metalGrillNormal.jpg",
  "metalGrill2Normal.jpg",
];
const VERSION = "v2.0.6";
const TOTAL_GROUP_ASSET_SIZE_MB = 500;
const DEBUG = false;

const DEFAULT_SCENE = `{"objects":[{"name":"cube1","material":{"diffuse":[0.5,0.5,0.5],"ambient":[0.10000000149011612,0.10000000149011612,0.10000000149011612],"specular":[0.10000000149011612,0.10000000149011612,0.10000000149011612],"n":12,"alpha":1,"shaderType":1,"diffuseTexture":{"name":"defaultDiffuse","texture":{}},"normalTexture":{"name":"defaultNormal","texture":{}}},"type":"cube","position":[0,0,0],"scale":[1,1,1],"rotation":[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],"parent":null,"model":null}],"pointLights":[{"name":"test-light-0","colour":[0.5,0.5,0.5],"position":[0,4,0],"strength":5,"quadratic":0.032,"linear":0.09,"constant":1,"nearPlane":0.1,"farPlane":1000,"shadow":false}],"skyBoxOn":false,"skyBoxPath":"defaultSkybox","sceneSettings":{"backgroundColor":{"0":0,"1":0,"2":0}},"camera":{"name":"Camera","position":[0,2,5],"front":[0,-0.3713906705379486,-0.9284766912460327],"up":[0,1,0],"yaw":90,"pitch":0,"roll":0,"viewMatrix":{"0":1,"1":0,"2":0,"3":0,"4":0,"5":0.9284766912460327,"6":0.3713906705379486,"7":0,"8":0,"9":-0.3713906705379486,"10":0.9284766912460327,"11":0,"12":0,"13":-2.9802322387695312e-8,"14":-5.385164737701416,"15":1},"moveSpeed":5,"sensitivity":0.009}}`

// UI CONSTANTS
export const DRAWER_WIDTH = 400;
export const HEADER_HEIGHT = 64;
export const PRIMARY_COLOUR = "#00b5ad";
export const SECONDARY_COLOUR = "#b55e00";

export { BACKEND_URL, DEBUG, DEFAULT_SCENE, DIFFUSE_TEXTURES, NORMAL_TEXTURES, TOTAL_GROUP_ASSET_SIZE_MB, VERSION };
